import React from 'react'
import { string, node } from 'prop-types'

import classNames from 'src/common/helpers/class-names'

import Volume from './volume'
import Title from './title'
import Rating from './rating'
import Promo from './promo'
import PricePerUOM from './price-per-uom'
import WasPrice from './was-price'
import Price from './price'
import LinkSavePrimaryBanner from './link-save-primary-banner'

import './_style.scss'

const blk = 'co-product'

const Product = ({ className, children }) => (
  <div className={classNames({ blk, className })}>{children}</div>
)

Product.propTypes = { className: string, children: node }
Product.defaultProps = { className: '', children: null }

export {
  Product as default,
  Volume,
  Title,
  Rating,
  Promo,
  PricePerUOM,
  WasPrice,
  Price,
  LinkSavePrimaryBanner,
}



// WEBPACK FOOTER //
// ./shared/interim/product/index.js